import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const HistoryTransfer = () => {
    const { id } = useParams();

    const [detailData, setDetailData] = useState(null);
    const [error, setError] = useState(null);

    const BASE_URL = "http://localhost/hijrah-backend";
    const PATH_DATA_TRANSFER = "/api/erpppsu/cash-bank/transfer";

    const fetchData = async (url) => {
        try {
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    useEffect(() => {
        if (id) {
            fetchData(`${BASE_URL}${PATH_DATA_TRANSFER}/detail?id=${id}`).then((data) => {
                setDetailData(data)
            });
        }
    }, [id]);

    return (
        <div className="mx-auto p-4">
            <div className='flex items-center justify-between p-5'>
                <div className='flex flex-col'>
                    <label className='font-semibold text-gray-500'>Transaksi</label>
                    <h2 className="text-2xl font-bold mb-4">
                        Bank Transfer {detailData?.no_transaction}
                    </h2>
                </div>

                <div className='flex items-center'>
                </div>
            </div>

            <div className="container m-auto  p-5 bg-[#E0F7FF] border-2 ">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6 ">
                    <div className='flex flex-col gap-5'>
                        <div className='flex flex-row'>
                            <div class="basis-1/3  font-bold">
                                <p>Transfer Dari</p>
                            </div>
                            <div class="basis-2/3">
                                <p>{detailData?.source_bank_name}</p>
                            </div>
                        </div>
                        <div className='flex flex-row'>
                            <div class="basis-1/3  font-bold">
                                <p>Setor Ke</p>
                            </div>
                            <div class="basis-2/3">
                                <p>{detailData?.target_bank_name}</p>
                            </div>
                        </div>
                        <div className='flex flex-row'>
                            <div class="basis-1/3  font-bold">
                                <p>Tgl Transaksi</p>
                            </div>
                            <div class="basis-2/3">
                                <p>{detailData?.date}</p>
                            </div>
                        </div>
                        <div className='flex flex-row'>
                            <div class="basis-1/3  font-bold">
                                <p>Jumlah</p>
                            </div>
                            <div class="basis-2/3">
                                <p>Rp {parseFloat(detailData?.amount).toLocaleString("id-ID")}</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-col'>
                        <div class="font-bold">
                            <p>Memo</p>
                        </div>
                        <div class="">
                            <p className=''>{detailData?.memo}</p>
                        </div>
                    </div>
                    <div className='flex flex-col gap-5'>
                        <div className='flex flex-col'>
                            <div class="font-bold">
                                <p>No. Transaksi:</p>
                            </div>
                            <div class="">
                                <p>{detailData?.no_transaction}</p>
                            </div>
                        </div>
                        <div className='flex flex-col'>
                            <div class="font-bold">
                                <p>Tag:</p>
                            </div>
                            <div class="">
                                <p>{detailData?.tags}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default HistoryTransfer;
